
import Vue from 'vue'
import DocumentItem from '../document-item/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  components: { DocumentItem },
  mixins: [staticBlockMixin],
  props: {
    isSquare: {
      type: Boolean,
      required: false,
      default: false
    },
    noBorder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    convertedFilteredBlocks () {
      return this.blocksByTag.map(block => this.convertBlockFields(block))?.filter(block => !this.isDeadline(block))
    }
  },
  methods: {
    isDeadline (block: any) {
      const deadline = block?.mainFields?.find((field: { code: string }) => field?.code === 'file')?.deadline
      return !deadline ? false : Date.now() > (deadline)
    },

    getFileType () {
      return this.fields?.mainFields?.find((field: { code: string }) => field?.code === 'file')?.type?.toUpperCase() || ''
    },

    getFileSize () {
      return this.fields?.mainFields?.find((field: { code: string }) => field?.code === 'file')?.size || ''
    }
  }
})
